/* eslint-disable no-use-before-define,no-restricted-globals */
import React from 'react'
import { Fields, } from '../twd'

export const Filter = ({context}) => {

    return <React.Fragment> 
        <div className="row vertical-offset-sm">
        <div className="form-group col-md-3 col-xs-12" style={{ marginBottom:0 }}>
            <Fields.Select
                label="Filter by date"
                labelStyle={{ fontSize: 'inherit', marginBottom: '0' }}

                value={context.filterByDate}
                options={[
                    {label:'Today', value:'0' },
                    {label:'Last 7 days', value:'7'},
                    {label:'Last 30 days', value:'30' },
                    {label:'Last 60 days', value:'60' },
                    {label:'Last 90 days', value:'90' },
                    {label:'Last 180 days', value:'180' }
                ]}
                style={getSelectStyle()}
                optionStyle={optionStyle}
                onChange={(a) => {
                    let s = a.target.value
                    context.setFilterByDate(s)
                    location.hash = ''
                }} />
        </div>

        <div className="form-group col-md-3 col-xs-12" style={{marginBottom:0}}>
            <Fields.Select
                label="Show data as"
                labelStyle={{ fontSize: 'inherit', marginBottom: '0' }}
                value={context.showDataAs}
                options={[
                    {label:'Summary table', value:'summary-table' },
                    {label:'Price history', value:'price-history' },
                    context.hasTradeYield && {label:'Yield history', value:'yield-history' },
                ].filter(Boolean)}
                style={getSelectStyle()}
                optionStyle={optionStyle}
                onChange={(a) => {
                    let s = a.target.value
                    context.setShowDataAs(s)
                    location.hash = ''
                }} />
        </div>
        </div>            
    </React.Fragment>
}

const getSelectStyle = () => {
    const color = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-base-color')
        .trim() || '#5627d8'
    
    return {
        border: '1px solid ' + color,
        color: color,
        'marginBottom': '0',
        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#','%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
        display: 'block',
        fontSize: '15px',
        fontWeight: '500',
        padding: '5px 20px',
    }
}

const optionStyle = {
    color: 'var(--primary-base-color)',
    fontSize: '13px',
}
